import { useEffect, useState, useMemo  } from "react";
import ScopeScreenModel from "./ScopeScreenModel";
import { Box, Card, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import axiosBase from '../common/axiosBase';
import coreConfig from '../common/coreConfig';
import { useNavigate } from "react-router";
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import ArticleIcon from '@mui/icons-material/Article';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { logger } from "../App";

const viewAssignedEquipmentFieldString = "ViewAssignedEquipment";

function getViewAssignedEquipment(onClick) {
  return {
    field: 'ViewAssignedEquipment',
    headerName: 'View Assigned Equipment',
    width: 200,
    sortable: false,
    filterable: false,
    disableExport: true,
    disableColumnMenu: true,
    renderCell: (params) => (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
      >
        <Tooltip title="View Assigned Equipment">
          <VisibilityIcon
            sx={{ cursor: 'pointer' }}
            color="primary"
            fontSize="medium"
            onClick={() => onClick(params)}
          />
        </Tooltip>
      </Box>
    )
  };
};

export default function ScopeScreen() {
    const [state, setState] = useState({
        data: [],
        showConnectivity: false,
        showImages: true
    });

    const navigate = useNavigate();

    const addRelations = ({ data, id }) => {
        const relation = data.map(({ ScopeModelNames = "", ...items }) => ({
            ...items,
            ScopeModelNames,
            showCheck: ScopeModelNames && ScopeModelNames.includes(id.toString())
        }));
        const checkedRelations = relation.filter((relation) => relation.showCheck);
        const uncheckedRelations = relation.filter((relation) => !relation.showCheck);
        return [...checkedRelations, ...uncheckedRelations];
    };

    const fetchData = async () => {
        const { apiConfig } = coreConfig;
        try {
            const response = await axiosBase({
                api: apiConfig.endpoints.dashboard,
                method: apiConfig.reqMethod.POST
            });
            if (!response.data.success) {
                return;
            }
            setState(prevState => ({ ...prevState, data: response.data.records }));
        } catch (error) {
            logger.error({ error, message: "Error fetching scope data" });
        }
    };

    const onCellDoubleClick = ({ id }) => {
        setState(prevState => {
            const data = addRelations({ data: prevState.data, id });
            return { ...prevState, data, showConnectivity: true };
        });
    };

    const columns = useMemo(() => {
        const base = [...ScopeScreenModel.columns];
        const exists = base.find(col => col.field === viewAssignedEquipmentFieldString);
        if (!exists) {
            base.splice(4, 0, getViewAssignedEquipment(onCellDoubleClick));
        }
        return base;
    }, []);
   

    useEffect(() => {
        fetchData();
    }, []);

    const handleNavigation = (item) => {
        const id = item.EquipmentId;
        navigate(`/equipments/${id}?showRelation=Document`);
    };
    const toggleShowImages = () => setState(prevState => ({ ...prevState, showImages: !prevState.showImages }));
    return (
        <Grid container >
            <Grid size={state.showConnectivity ? 10 : 12} >
                <ScopeScreenModel.Grid columns={columns} onCellDoubleClickOverride={onCellDoubleClick}/>
            </Grid>
            {state.showConnectivity &&
                <Grid size={{ xs: 2 }} pl={2}>
                    <Box bgcolor={"white"} borderRadius={2}>
                        <Box display={"flex"} p={2} alignItems={"center"} justifyContent={"space-between"}>
                            <Typography variant="h5" color="rgba(0,0,0,0.6)">Equipments</Typography>
                            <Tooltip title={state.showImages ? "Collapse" : "Expand"}>
                                <IconButton onClick={toggleShowImages}>
                                    {state.showImages ? <CloseFullscreenIcon /> : <OpenInFullIcon />}
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <Box maxHeight={"80vh"} overflow={"auto"}>
                            {state.data.map((item, index) => {
                                return <Card variant="outlined" className="equipmentScopeCard" sx={{
                                    height: state.showImages ? 200 : 40,
                                    marginY: index && 1,
                                    borderLeft: `5px solid ${item.showCheck ? "green" : "red"}`
                                }} key={item.EquipmentId}>
                                    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                        <Box mx={"auto"} >
                                            <Typography pl={3}>{item.ModelName}</Typography>
                                        </Box>
                                        <Tooltip title="Document">
                                            <IconButton onClick={() => handleNavigation(item)} color="primary">
                                                <ArticleIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                    {state.showImages && <Box className="imageHolder">
                                        <Box component="img"
                                            src={`/${item.EquipmentTypeImage}`}
                                            alt="washer"
                                            loading="eager"
                                            sx={{
                                                height: theme => theme.spacing(15)
                                            }}
                                            className="cardBox"
                                        />
                                    </Box>}
                                </Card>;
                            })}
                        </Box>
                    </Box>
                </Grid>}
        </Grid>
    );
}
